import { Color, RGBA_ASTC_5x4_Format} from "three";

export const bodies = {
  sun: {
    ia: 0.011 * Math.random() + 0.01,
    ifreq: Math.round(19 * Math.random() + 4),
    ra: 4000 * Math.random() + 3000,
    rfreq: Math.round(18 * Math.random() + 6),
    precession: 0,
    distScale: 0.14,
    distRot: 1.06e-5,
    warp: true
  },
  neutronstar: {
    ia: 0.031 * Math.random() + 0.01,
    ifreq: Math.round(21 * Math.random() + 6),
    ra: 12000 * Math.random() + 6000,
    rfreq: Math.round(18 * Math.random() + 6),
    precession: 0,
    distScale: 0.28,
    warp: true,
    distRot: 6,
    precessRot: 70.5,
    magnetic: {
      inclinMag: 30,
      distMag: false,
      totalPhi: 18,
      totalRings: 10,
      desiredMaxRmax: 1426,
      desiredMinRmax: 2,
      lateralTwist: 0,
      twistFrequency: 0,
      amortMag: 0
    }
  },
  psoj: {
    ia: 0.01 * Math.random() + 0.007,
    ifreq: Math.round(34 * Math.random() + 14),
    ra: 78600 * Math.random() + 4500,
    rfreq: Math.round(12 * Math.random() + 4),
    precession: 0,
    distScale: 0.05,
    distRot: 2.56e-6,
    warp: true,
    precessRot: 0,
    atm:null
  },
  mercury: {
    ia: 0.0002,
    ifreq: 0.02,
    ra: 0.03 * Math.random() + 0.015,
    rfreq: Math.round(3 * Math.random() + 1),
    precession: 2.54e-7,
    distScale: 0.051,
    distRot: 5.0e-10,
    precessRot: 3.62e-5,
    atm:new Color(0x4C4C4C),
    magnetic: {
      inclinMag: 5,
      distMag: false,
      totalPhi: 10,
      totalRings: 6,
      desiredMaxRmax: 3,
      desiredMinRmax: 1.5,
      lateralTwist: 0.05,
      twistFrequency: 0.02,
      amortMag: 0.3
    }
  },

  venus: {
    ia: 0.0002,
    ifreq: 0.02,
    ra: 0.03 * Math.random() + 0.015,
    rfreq: Math.round(3 * Math.random() + 1),
    precession: 9.02e-8,
    distScale: 0.051,
    distRot: 3.0e-9,
    precessRot: -6.87e-7,
    atm:new Color(0xF5F2E0)
  },
  earth: {
    ia: 0.001,
    ifreq: 0.337,
    ra: 0.001 * Math.random() + 0.0007,
    rfreq: Math.round(6 * Math.random() + 2),
    precession: 5.05e-7,
    distScale: 0.065,
    distRot: 3.5e-9,
    precessRot: 7.73e-7,
    atm:new Color(0x649ABE),
    magnetic: {
      inclinMag: 11,
      distMag: false,
      totalPhi: 10,
      totalRings: 5,
      desiredMaxRmax: 20,
      desiredMinRmax: 3,
      lateralTwist: 0.03,
      twistFrequency: 0.02,
      amortMag: 50
    },
    haveMoon: true,
    distShadow: 80
  },
  moon: {
    ia: 0.001,
    ifreq: 0.0127,
    ra: 0.0002 * Math.random(),
    rfreq: Math.round(0.01 * Math.random() + 0.001),
    precession: 2.25e-3,
    distScale: 0.047,
    distRot: 1.6e-10,
    precessRot: 0
  },
  mars: {
    ia: 0.0005,
    ifreq: 0.05,
    ra: 0.005 * Math.random() + 0.003,
    rfreq: Math.round(5 * Math.random() + 1),
    precession: 7.18e-7,
    distScale: 0.056,
    distRot: 7.0e-10,
    precessRot: 1.15e-7,
    atm:new Color(0xC58D75) 
  },
  jupiter: {
    ia: 0.0001,
    ifreq: 0.002,
    ra: 0.005 * Math.random() + 0.002,
    rfreq: Math.round(3 * Math.random() + 1),
    precession: 2.89e-7,
    distScale: 0.1,
    distRot: 2.87e-7,
    precessRot: 4.21e-8,
    atm:new Color(0xB07F35),
    magnetic: {
      inclinMag: 10,
      distMag: false,
      totalPhi: 14,
      totalRings: 5,
      desiredMaxRmax: 160,
      desiredMinRmax: 2,
      lateralTwist: 0.04,
      twistFrequency: 0.01,
      amortMag: 8e4
    },
    haveMoon: true,
    distShadow: 70
  },
  saturn: {
    ia: 0.0001,
    ifreq: 0.0015,
    ra: 0.004 * Math.random() + 0.0015,
    rfreq: Math.round(3 * Math.random() + 1),
    precession: 8.61e-7,
    distScale: 0.094,
    distRot: 3.6e-8,
    precessRot: 1.09e-8,
    atm:new Color(0xB08F36),
    magnetic: {
      inclinMag: 2,
      distMag: false,
      totalPhi: 13,
      totalRings: 5,
      desiredMaxRmax: 60,
      desiredMinRmax: 2,
      lateralTwist: 0.03,
      twistFrequency: 0.01,
      amortMag: 7e4
    },
    haveMoon: true,
    distShadow: 70
  },
  uranus: {
    ia: 0.0002,
    ifreq: 0.001,
    ra: 0.003 * Math.random() + 0.001,
    rfreq: Math.round(2 * Math.random() + 1),
    precession: 0,//1.48e-7,
    distScale: 0.084,
    distRot: 1.3e-8,
    precessRot: 9.48e-5,
    atm:new Color(0x4FD0E7),
    magnetic: {
      inclinMag: 60,
      distMag: false,
      totalPhi: 12,
      totalRings: 4,
      desiredMaxRmax: 46,
      desiredMinRmax: 2,
      lateralTwist: 0.02,
      twistFrequency: 0.005,
      amortMag: 2e5
    },
    haveMoon: true,
    distShadow: 70
  },
  neptune: {
    ia: 0.0002,
    ifreq: 0.001,
    ra: 0.0003 * Math.random() + 0.001,
    rfreq: Math.round(2 * Math.random() + 1),
    precession: 5.53e-9,
    distScale: 0.082,
    distRot: 1.6e-8,
    precessRot: 1.07e-8,
    atm:new Color(0x7CB7BB), 
    magnetic: {
      inclinMag: 47,
      distMag: false,
      totalPhi: 12,
      totalRings: 3,
      desiredMaxRmax: 50,
      desiredMinRmax: 2,
      lateralTwist: 0.05,
      twistFrequency: 0.003,
      amortMag: 2.6e5
    },
    haveMoon: true,
    distShadow: 30
  },
  pluto: {
    ia: 0.0003,
    ifreq: 0.003,
    ra: 0.00013 * Math.random() + 0.0018,
    rfreq: Math.round(2 * Math.random() + 1),
    precession: 1.54e-8,
    distScale: 0.04,
    distRot: 4.1e-11,
    precessRot: 9.06e-7,
    haveMoon: true,
    distShadow: 30,
    atm:new Color(0x9BB8CC)
  },
  europa: {
    ia: 0.0001,
    ifreq: 0.0009,
    ra: 0.00012 * Math.random(),
    rfreq: Math.round(3 * Math.random() + 1),
    precession: 1.03e-3,
    distScale: 0.035,
    distRot: 1e-10,
    precessRot: 1.03e-3,
    precessAlignToEq:true
  },
  callisto: {
    ia: 0.0001,
    ifreq: 0.0005,
    ra: 0.00013 * Math.random(),
    rfreq: Math.round(3 * Math.random() + 1),
    precession: 2.78e-5,
    distScale: 0.031,
    distRot: 1e-10,
    precessRot: 2.78e-5,
    precessAlignToEq:true
  },
  ganymede: {
    ia: 0.0001,
    ifreq: 0.0002,
    ra: 0.00013 * Math.random() + 0.001,
    rfreq: Math.round(3 * Math.random() + 1),
    precession: 2.01e-4,
    distScale: 0.022,
    distRot: 1e-10,
    precessRot: 2.01e-4,
    precessAlignToEq:true,
    magnetic: {
      inclinMag: 0,
      distMag: false,
      totalPhi: 4,
      totalRings: 3,
      desiredMaxRmax: 3,
      desiredMinRmax: 1.5,
      lateralTwist: 0.01,
      twistFrequency: 0.03,
      amortMag: 1.2
    }
  },
  io: {
    ia: 0.0001,
    ifreq: 0.0003,
    ra: 1e-4,
    rfreq: Math.round(0.03 * Math.random() + 0.01),
    precession: 5.23e-3,
    distScale: 0.047,
    distRot: 1e-10,
    precessRot: 5.23e-3,
    precessAlignToEq:true
  },
    mimas: {
    ia: 0.000018,
    ifreq: 0.00018,
    ra: 0.000038,
    rfreq: 1,
    precession: 0.0065,
    distScale: 0.014,
    distRot: 1e-12,
    precessRot: 0.0065,
    precessAlignToEq:true
  },
  dione: {
    ia: 0.00001,
    ifreq: 0.000001,
    ra: 0.000002 * Math.random() + 0.0001,
    rfreq: Math.round(3 * Math.random() + 1),
    precession: 3.31e-3,  
    distScale: 0.031,
    distRot: 1e-11,
    precessRot: 3.31e-3,
    precessAlignToEq:true  
  },
  iapetus: {
    ia: 0.000001,
    ifreq: 0.0007,
    ra: 0.000002 * Math.random() + 0.001,
    rfreq: Math.round(3 * Math.random() + 1),
    precession: 1.17e-6,
    distScale: 0.025,
    distRot: 1e-11,
    precessRot: 1.17e-6,
    precessAlignToEq:true
  },
  titan: {
    ia: 0.0001,
    ifreq: 0.0015,
    ra: 0.0002 * Math.random() + 0.001,
    rfreq: Math.round(3 * Math.random() + 1),
    precession: 5.43e-5,
    distScale: 0.042,
    distRot: 1e-10,
    precessRot: 5.43e-5,
    precessAlignToEq:true
  },
  rhea: {
    ia: 0.0001,
    ifreq: 0.0008,
    ra: 0.0002 * Math.random() + 0.001,
    rfreq: Math.round(3 * Math.random() + 1),
    precession: 1.03e-3,
    distScale: 0.025,
    distRot: 1e-11,
    precessRot: 1.03e-3,
    precessAlignToEq:true
  },
  tethys: {
    ia: 0.00002,
    ifreq: 0.0002,
    ra: 0.0001 * Math.random(),
    rfreq: Math.round(1 * Math.random() + 0.002),
    precession: 7.87e-3,
    distScale: 0.020,
    distRot: 1e-11,
    precessRot: 7.87e-3,
    precessAlignToEq:true
  },
  triton: {
    ia: 0.00001,
    ifreq: 0.00012,
    ra: 0.00002 * Math.random(),
    rfreq: Math.round(1 * Math.random() + 0.0001),
    precession: 4.92e-5,
    distScale: 0.033,
    distRot: 1e-11,
    precessRot: 4.92e-5
  },
  charon: {
    ia: 0.00000032,
    ifreq: 0.000007,
    ra: 0.00001 * Math.random(),
    rfreq: Math.round(1 * Math.random() + 0.0002),
    precession: 0,   
    distScale: 0.021,
    distRot: 1e-12,
    precessRot: 0   
  },
  titania: {
    ia: 0.00000005,
    ifreq: 0.000001,
    ra: 0.00002 * Math.random(),
    rfreq: 0.0000001,
    precession: 2.83e-5,
    distScale: 0.026,
    distRot: 1e-12,
    precessRot: 2.83e-5,
    precessAlignToEq:true
  },
  oberon: {
    ia: 0.000002,
    ifreq: 0.00001,
    ra: 0.00001 * Math.random(),
    rfreq: Math.round(1 * Math.random() + 0.00000221),
    precession: 1.02e-5,
    distScale: 0.025,
    distRot: 1e-12,
    precessRot: 1.02e-5,
    precessAlignToEq:true
  },
  umbriel: {
    ia: 0.0000006,
    ifreq: 0.00004,
    ra: 0.00001 * Math.random(),
    rfreq: Math.round(1 * Math.random() + 0.000341),
    precession: 1.60e-4,
    distScale: 0.021,
    distRot: 1e-12,
    precessRot: 1.60e-4,
    precessAlignToEq:true
  },
    miranda: {
    ia: 0.000025,
    ifreq: 0.00022,
    ra: 0.000072,
    rfreq: 1,
    precession: 0.0082,
    distScale: 0.01,
    distRot: 1e-11,
    precessRot: 0.0082,
    precessAlignToEq:true
  },
  ariel: {
    ia: 0.000001,
    ifreq: 0.00004,
    ra: 0.00001 * Math.random(),
    rfreq: Math.round(1 * Math.random() + 0.00021),
    precession: 5.11e-4,
    distScale: 0.021,
    distRot: 1e-12,
    precessRot: 5.11e-4,
    precessAlignToEq:true
  },
  halleyscomet: {
    ia: 0,
    ifreq: 0,
    ra: 0,
    rfreq: 0,
    precession: 2.04e-11, 
    distScale: 0.0001,
    distRot: 0,
    precessRot: 0    
  },
  sagittariusa: {
    distScale: 0.35,
    distRot: 5
  },
  whitehole: {
    distScale: -0.35,
    distRot: 2
  }
};


